import { DeleteOutlined } from '@ant-design/icons';
import { App, Popconfirm } from 'antd';
import { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { webhooksActions } from '@store/webhooks/webhooks.slice';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useDeleteWebhookMutation } from '@hook/webhook/webhook.hooks';

interface DeleteWebhookProps {
  id: string;
}

export const DeleteWebhook = memo(({ id }: DeleteWebhookProps) => {
  const dispatch = useDispatch();
  const { action, state } = useMutation(useDeleteWebhookMutation(), webhooksActions);
  const { message } = App.useApp();

  const handleDelete = useCallback(
    () => action(id).then(() => message.success('Webhook was successfully deleted')),
    [id, action, message],
  );

  useEffect(() => void (state.isSuccess && dispatch(webhooksActions.removeWebhook(id))), [state.isSuccess, id]);

  return (
    <Popconfirm
      cancelText='No'
      description='Are you sure to delete this webhook?'
      okText='Yes'
      placement='left'
      title='Delete the webhook'
      onConfirm={handleDelete}
    >
      <Button title='Delete webhook' type={ButtonTypeEnum.Error}>
        <DeleteOutlined />
      </Button>
    </Popconfirm>
  );
});
